import { useNavigation } from '@react-navigation/native';
import { StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice } from 'utils/index';

import NewGradientButton from 'components/Button/NewGradienteButton';

type EmptyStateProps = {
  title?: string;
  description?: string;
  buttonText?: string;
};

const EmptyState = ({
  title = 'Nada por aqui =(',
  description = 'Desculpe, não encontramos conteúdo aqui no momento.',
  buttonText = 'Acesse nossos conteúdos',
}: EmptyStateProps) => {
  const navigation = useNavigation<any>();

  const handlePress = () => navigation.navigate('Home');

  return (
    <View style={styles.container}>
      <Text style={styles.title}>{title}</Text>
      <Text style={styles.description}>{description}</Text>
      <NewGradientButton style={styles.button} onPress={handlePress}>
        <Text style={styles.buttonText}>{buttonText}</Text>
      </NewGradientButton>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 40,
    paddingVertical: 60,
    height: calcSizeForDevice(500),
  },
  title: {
    fontSize: calcSizeForDevice(48),
    fontWeight: '600',
    color: '#FFF',
    textAlign: 'center',
    marginBottom: calcSizeForDevice(24),
  },
  description: {
    fontSize: calcSizeForDevice(32),
    color: '#AAA',
    textAlign: 'center',
    marginBottom: calcSizeForDevice(32),
  },
  button: {
    height: calcSizeForDevice(54),
  },
  buttonText: {
    color: '#070D31',
    fontWeight: '600',
    fontSize: calcSizeForDevice(24),
    marginHorizontal: calcSizeForDevice(12),
  },
});

export default EmptyState;
